import MaterialFormControl from '@material-ui/core/FormControl'
import styled from 'styled-components'

export const FormControl = styled(MaterialFormControl)`
  width: 100%;
`
